import React from 'react';
import {observer} from 'mobx-react';
import {useGoogleLogin} from '@react-oauth/google';
import {LoginWeb, LoginMobile} from 'components';
import {
  useAuthStore,
  useLoaderStore,
  useUserStore,
} from 'contexts/StoreContext';
import {useWindowDimensions} from 'react-native';
import {getSize} from 'helpers/getSize';
import {DEVICE_SIZES} from 'rn-responsive-styles';
import {LoginScreenProps} from 'navigations/AuthFlow';
import {Flows} from 'navigations/Screens';

const LoginScreen = observer((props: LoginScreenProps) => {
  const authStore = useAuthStore();
  const userStore = useUserStore();
  const loaderStore = useLoaderStore();

  const width = useWindowDimensions().width;

  const signIn = useGoogleLogin({
    onSuccess: async codeResponse => {
      try {
        loaderStore.startLoading();
        await authStore.signIn(codeResponse.code);
        await userStore.getCurrentUserIfNeeded();
        loaderStore.stopLoading();

        props.navigation.push(Flows.tabBarFlow);
      } catch (err) {
        console.log(err);
        loaderStore.stopLoading();
      }
    },
    flow: 'auth-code',
  });

  if (width > getSize(DEVICE_SIZES.EXTRA_SMALL_DEVICE)) {
    return <LoginWeb onPress={signIn} />;
  }

  return <LoginMobile onPress={signIn} />;
});

export default LoginScreen;
